module.exports = __webpack_public_path__ + "static/media/cover.0aa2bb46.png";